import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { notification } from 'antd';
import i18n from 'i18next';


// 401 = no/invalid token → sign the user out.
// 403 = authenticated but lacks permission for this specific call → DO NOT
// sign out; just surface the error. Conflating the two used to kick users to
// login the moment any single API call lacked perms, which is a terrible UX
// for role-scoped users (e.g. a SALES_MANAGER hitting a lead endpoint they
// only have _OWN scope for).
const signOutCodes = [401]

const service = axios.create({
	baseURL: API_BASE_URL,
	timeout: 60000
})

// Config
const TOKEN_PAYLOAD_KEY = 'Authorization'

// API Request interceptor
service.interceptors.request.use(config => {
	const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

	if (jwtToken) {
		config.headers[TOKEN_PAYLOAD_KEY] = "Bearer " + jwtToken
	}

	// Skip ngrok's browser interstitial when the API is exposed through a free
	// ngrok tunnel during dev (the page returned otherwise breaks CORS for the
	// browser since it lacks our Access-Control-* headers). No-op against
	// non-ngrok hosts — they ignore the unknown header.
	config.headers['ngrok-skip-browser-warning'] = 'true'
	// Idioma de la UI: el backend traduce los mensajes de error cuando es 'en'
	// (ErrorLanguageInterceptor).
	config.headers['x-lang'] = i18n.language || 'es'

	return config
}, error => {
	// Do something with request error here
	notification.error({
		message: 'Error'
	})
	Promise.reject(error)
})

// API respone interceptor
service.interceptors.response.use((response) => {

	return response.data
}, (error) => {

	let notificationParam = {
		message: ''
	}

	// 401 only: token missing/expired → force re-login.
	if (signOutCodes.includes(error.response.status)) {
		notificationParam.message = error.response.data.message
		notificationParam.description = 'Please login again'
		localStorage.removeItem(AUTH_TOKEN)

		store.dispatch(signOutSuccess())
	}

	// 403: authenticated, just missing permission for this call. Show the
	// backend's message but keep the user logged in.
	if (error.response.status === 403) {
		notificationParam.message = error.response.data.message || i18n.t('layout.fetchInterceptor.forbidden')

	}

	if (error.response.status === 400 || error.response.status === 409) {
		notificationParam.message = error.response.data.message
	}

	if (error.response.status === 404) {
		notificationParam.message = error.response.data.message
	}

	if (error.response.status === 500) {
		notificationParam.message = 'Internal Server Error'
	}

	if (error.response.status === 508) {
		notificationParam.message = 'Time Out'
	}

	notification.error(notificationParam)

	return Promise.reject(error);
});

export default service